import { z } from 'zod';

export const templateSchema = z.object({
  name: z.string()
    .min(2, 'Template name must be at least 2 characters')
    .max(100, 'Template name must not exceed 100 characters'),
  description: z.string().optional(),
});

export type CreateTemplateData = {
  name: string;
  description?: string;
};